import { FunctionComponent } from "react";
import { UsersSelect, UsersSelectProps } from "../../pickers/UsersSelect";
import {
  FieldItem,
  FieldItemStyleProps,
  FieldItemStyles,
  IStyleFunctionOrObject,
  useFieldContext,
  useFieldRegister
} from "@bps/fluent-ui";

type FormUsersSelectProps = Omit<
  UsersSelectProps,
  "selectedKeys" | "onChangeSelectedKeys"
> & {
  fieldItemStyles?: IStyleFunctionOrObject<
    FieldItemStyleProps,
    FieldItemStyles
  >;
  name: string;
};

export const FormUsersSelect: FunctionComponent<FormUsersSelectProps> = ({
  name,
  fieldItemStyles,
  ...restUsersSelectProps
}) => {
  useFieldRegister(name);
  const { meta, value, setFieldValue } = useFieldContext<
    string | string[] | undefined
  >(name);

  return (
    <FieldItem name={name} errorMessage={meta?.error} styles={fieldItemStyles}>
      <UsersSelect
        selectedKeys={value}
        onChangeSelectedKeys={setFieldValue}
        {...restUsersSelectProps}
      />
    </FieldItem>
  );
};
